

























import Vue from 'vue';

export default class FileMenu extends Vue {
  private stopPropagation = (event: MouseEvent) => {
    event.stopPropagation();
  }
}
